/** 后端统一成功码（Spring ApiResponse） */
export const API_SUCCESS_CODE = "0";

/** 用户端 Sa-Token 请求头（dev 默认，与本地 sa-token.token-name 一致） */
export const SA_TOKEN_HEADER = "satoken";

/** 用户端 Sa-Token 请求头（prod 默认，与线上 sa-token.token-name 一致） */
export const SA_TOKEN_HEADER_PROD = "Authorization";

/** 管理端 Sa-Token 请求头（loginType=admin，与后端 StpAdminUtil 配置一致） */
export const ADMIN_TOKEN_HEADER = "admin-token";

/** 可选：已登录时写入便于日志对齐，不作为鉴权依据 */
export const USER_PUBLIC_ID_HEADER = "X-User-Public-Id";

/** 历史：用户端本地 API 覆盖（web 已弃用写入，保留 key 便于清理） */
export const LS_API_BASE = "glyphicai-settings-api-base";

/** 默认 Vite 开发端口 → 回退到本机 8082 */
export const DEFAULT_DEV_VITE_PORTS = [
  "5173",
  "5174",
  "4173",
  "4174",
  "8848"
] as const;

export const DEFAULT_BACKEND_PORT = "8082";

export const DEFAULT_API_FALLBACK = "http://127.0.0.1:8082/api";
